<script>
    import LyContent from '../layouts/components/LyContent.svelte';
    import LySection from '../layouts/components/LySection.svelte';
    import LyHeadline from '../layouts/components/LyHeadline.svelte';
    import LyP from '../layouts/components/LyP.svelte';
    import LyHeader from '../layouts/components/LyHeader.svelte';
    import LyGrid3 from '../layouts/components/LyGrid3.svelte';
    import { NavigationStore, PageStore } from '../stores/PageStore.svelte.js';
    import LyButton from '../layouts/forms/LyButton.svelte';
    import LyButtons from '../layouts/forms/LyButtons.svelte';
    import * as Icons from 'lucide-svelte';
</script>

<LyContent wrapper={true}>
    <LyHeader>
        <LyHeadline icon={Icons.ShieldCheck}>Administrator</LyHeadline>
    </LyHeader>

    <LySection tag="div">
        <LyP>
            In diesem Bereich findest Du alle Werkzeuge, die Du für
            <strong>administrative Aufgaben</strong> benötigst.
        </LyP>
    </LySection>
</LyContent>

<LyGrid3 wrapper={true} mt={true}>
    {#each NavigationStore.listAdmin as item}
        <LyContent tag="article" addClass="flex h-full flex-col">
            <LyHeader>
                <LyHeadline weight={2} center={true}>
                    {item.label}
                </LyHeadline>
            </LyHeader>
            <LyP center={true}>
                {item.description}
            </LyP>
            <div class="mt-auto">
                <LyButtons mt={true} center={true}>
                    <LyButton label={item.button || item.label} onclick={() => PageStore.set(item.url)} />
                </LyButtons>
            </div>
        </LyContent>
    {/each}
</LyGrid3>
